export enum MobileTabsValues {
  LATEST_UPDATES = 'latestUpdates',
  OUR_VISION = 'ourVision',
  COMPANY_INFO = 'companyInfo',
  OUR_KPI_TARGET = 'ourKpiTarget',
  OUR_TEAM = 'ourTeam',
  MY_SCHEDULE = 'mySchedule',
  MY_TASK = 'myTask',
  MY_PINNED_POSTS = 'myPinnedPosts',
  MY_QUICK_LINKS = 'myQuickLinks',
}
